/**
 * Page through results with Ajax.
 * @constructor
 * @param {string} componentId
 * @param {string} view
 * @param {string} navlinksSel
 * @param {string} pageParam
 * @public
 */
Foundation.Paginator = function (componentId, view, navlinksSel, pageParam) {
    this.componentId = componentId;
    this.view = jQuery(`#${view}`);
    this.navlinksSel = navlinksSel;
    this.pageParam = pageParam || "page";
    this.navigationLinkSeutp();
    this.inProgress = false;
};

/**
 * @private
 */
Foundation.Paginator.prototype.navigationLinkSeutp = function () {
    var links = this.view.find(this.navlinksSel);
    links.click(this.requestPage.bind(this));
};

/**
 * @param {jQuery.Event} clickEvent
 * @private
 */
Foundation.Paginator.prototype.requestPage = function (clickEvent) {
    clickEvent.preventDefault();
    if (this.inProgress) return;
    this.inProgress = true;
    
    var requestParams = {};
    var href = /** @type {string} */ (jQuery(clickEvent.target).closest("a").attr("href"));
    var link = new Foundation.URL(href);
    requestParams[this.pageParam] = link.get(this.pageParam);
    
    this.spinner = new Foundation.View.Spinner(this.view[0], { "delay": 1 });
    new Foundation.Ajax(this.componentId, {
        "method": "get",
        "parameters": requestParams,
        "onSuccess": this.updatePage.bind(this),
        "onComplete": this.reset.bind(this)
    });
};

/**
 * @param {Ajax.Response} r
 * @private
 */
Foundation.Paginator.prototype.updatePage = function (r) {
    this.spinner.hide();
    this.spinner = null;
    
    new Effect.Opacity($(this.view[0]), {
        "duration": 0.3,
        "from": 1,
        "to": 0,
        "afterFinish": (function () {
            $(this.view[0]).update(r.responseText);
            $(this.view[0]).appear({ "duration": 0.3 });
            this.navigationLinkSeutp();
        }).bind(this)
    });
};

/**
 * @private
 */
Foundation.Paginator.prototype.reset = function () {
    this.inProgress = false;
    if (this.spinner) this.spinner.hide();
};

// ---------------------------------------------------------------------

window["Foundation"]["Paginator"] = Foundation.Paginator;

// ---------------------------------------------------------------------

